/* -------------------------------------------------------------
   🟢 staffelung.js — FINAL CLEAN MASTER VERSION
   Shopify Theme: Refresh 12.0.0

   Supports:
   • Verdopplungsaktion → min 3, step 3, remaining-stock logic, DOUBLES in cart
   • tripleup → min 3, step 3, remaining-stock logic
   • unified low-stock mode (<3 & deny)
   • dynamic remaining stock: inventory - cart quantity
   • toast alerts (pretty + centered)
   • ZERO interference with normal (untagged) products
--------------------------------------------------------------*/

console.log("🟢 Triple-Up + Verdopplungsaktion JS Loaded");

/* -------------------------------------------------------------
   CONFIG
--------------------------------------------------------------*/
const MIN = 3;
const STEP = 3;

/* Toast styling */
const TOAST_STYLE = `
  position: fixed !important;
  bottom: 25px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  background: #fbf555 !important;
  color: #000 !important;
  padding: 10px 18px !important;
  border-radius: 10px !important;
  border: 1px solid #396742 !important;
  font-weight: 900 !important;
  z-index: 999999999 !important;   /* <-- MUCH HIGHER */
  box-shadow: 0 0 10px rgba(0,0,0,0.15) !important;
  font-size: 1.1rem !important;
  pointer-events: none !important;  /* prevents drawer blocking clicks */
`;

/* -------------------------------------------------------------
   TOAST MESSAGE
--------------------------------------------------------------*/
function showToast(msg) {
  const div = document.createElement("div");
  div.textContent = msg;
  div.style = TOAST_STYLE;
  document.body.appendChild(div);
  setTimeout(() => div.remove(), 2500);
}

/* -------------------------------------------------------------
   HELPERS
--------------------------------------------------------------*/
function isTripleUp(input) {
  return input.dataset.tripleup === "true";
}
function isVerdopplung(input) {
  return input.dataset.verdopplung === "true";
}
function isEnhancedInput(input) {
  return isTripleUp(input) || isVerdopplung(input);
}

function getRemainingStock(input) {
  const stock = parseInt(input.dataset.stock);
  const inCart = parseInt(input.dataset.cartQuantity) || 0;
  return Math.max(stock - inCart, 0);
}

function isLowStock(input, remaining) {
  return (
    input.dataset.policy === "deny" &&
    remaining < MIN
  );
}

function normalizeToStep(val) {
  val = parseInt(val);
  if (isNaN(val) || val < MIN) return MIN;
  return Math.ceil(val / STEP) * STEP;
}

/* -------------------------------------------------------------
   LOW STOCK MODE (1–2 units left)
--------------------------------------------------------------*/
function applyLowStockMode(input, remaining) {
  input.value = remaining;
  input.min = remaining;
  input.max = remaining;
  input.step = 1;
}

/* -------------------------------------------------------------
   NORMAL MODE (min=3, step=3)
--------------------------------------------------------------*/
function applyNormalMode(input, remaining) {
  const usable = remaining - (remaining % STEP) || STEP;

  input.min = MIN;
  input.step = STEP;
  input.max = usable;
  input.value = MIN;
}

/* -------------------------------------------------------------
   CART UPDATE FUNCTION
--------------------------------------------------------------*/
async function updateCartLine(input) {
  const index = parseInt(input.dataset.index);
  if (!index) return;

  let q = parseInt(input.value);

  // Verdopplungsaktion rule
  if (isVerdopplung(input)) {
    q = q * 2;
  }

  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ line: index, quantity: q })
  });

  document.dispatchEvent(new Event("cart:updated"));
}

/* -------------------------------------------------------------
   INIT SINGLE INPUT
--------------------------------------------------------------*/
function initInput(input) {
  if (!isEnhancedInput(input)) return;

  const remaining = getRemainingStock(input);
  const lowStock = isLowStock(input, remaining);

  /* ---------- LOW STOCK (1–2 left) ---------- */
  if (lowStock) {
    applyLowStockMode(input, remaining);

    input.addEventListener("change", () => {
      input.value = remaining;
      showToast(`Nur noch ${remaining} Stück verfügbar`);
    });

    return;
  }

  /* ---------- NORMAL MODE (3,6,9...) ---------- */
  applyNormalMode(input, remaining);

  const minus = input.parentElement.querySelector('[name="minus"]');
  const plus = input.parentElement.querySelector('[name="plus"]');

  /* Remove Shopify listeners */
  function reset(btn) {
    if (!btn) return null;
    const clone = btn.cloneNode(true);
    btn.replaceWith(clone);
    return clone;
  }

  const minusBtn = reset(minus);
  const plusBtn = reset(plus);

  /* ---- PLUS ---- */
  if (plusBtn) {
    plusBtn.addEventListener("click", () => {
      const next = parseInt(input.value) + STEP;

      if (next > input.max) {
        console.log("TOAST SHOULD FIRE — next:", next, "max:", input.max);
        showToast("Nicht genug Bestand");
        return;
      }

      input.value = next;
      if (input.dataset.index) updateCartLine(input);
    });
  }

  /* ---- MINUS ---- */
  if (minusBtn) {
    minusBtn.addEventListener("click", () => {
      const next = parseInt(input.value) - STEP;
      input.value = Math.max(MIN, next);
      if (input.dataset.index) updateCartLine(input);
    });
  }

  /* ---- MANUAL INPUT ---- */
  input.addEventListener("change", () => {
    let next = normalizeToStep(input.value);
    if (next > input.max) {
      next = input.max;
      showToast("Nicht genug Bestand");
    }
    input.value = next;
    if (input.dataset.index) updateCartLine(input);
  });
}

/* -------------------------------------------------------------
   INITIALIZE ONLY THE ENHANCED INPUTS
--------------------------------------------------------------*/
function initAllInputs() {
  document
    .querySelectorAll(
      "input.quantity__input[data-tripleup], input.quantity__input[data-verdopplung]"
    )
    .forEach(initInput);
}

/* -------------------------------------------------------------
   EVENT LISTENERS
--------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", initAllInputs);
document.addEventListener("cart:updated", () => setTimeout(initAllInputs, 60));
document.addEventListener("shopify:section:load", () => setTimeout(initAllInputs, 60));
document.addEventListener("product:added", () => setTimeout(initAllInputs, 80));
document.addEventListener("cart-drawer:close", () => setTimeout(initAllInputs, 80));
